<template>
  <span
    class="tp-pill"
    :class="[draggable && 'tp-pill--drag', solid && 'tp-pill--solid']"
    :draggable="draggable"
    @dragstart="$emit('dragstart', $event)"
    @dragover="$emit('dragover', $event)"
    @drop="$emit('drop', $event)"
  >
    <input
      v-if="editable"
      class="tp-pill__input"
      :value="modelValue"
      :style="inputWidth ? { width: inputWidth } : null"
      v-bind="$attrs"
      @input="$emit('update:modelValue', $event.target.value)"
    />
    <span v-else class="tp-pill__label">{{ modelValue }}</span>
    <button
      v-if="removable"
      type="button"
      class="tp-pill__remove"
      aria-label="Remove"
      @click.stop="$emit('remove')"
    >
      <svg width="9" height="9" viewBox="0 0 10 10" fill="none">
        <path d="M1 1l8 8M9 1l-8 8" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" />
      </svg>
    </button>
  </span>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Pill',
  inheritAttrs: false,
  props: {
    modelValue: { type: String, default: '' },
    editable: { type: Boolean, default: false },
    draggable: { type: Boolean, default: false },
    removable: { type: Boolean, default: true },
    solid: { type: Boolean, default: false },
    inputWidth: { type: String, default: '' },
  },
  emits: ['update:modelValue', 'remove', 'dragstart', 'dragover', 'drop'],
});
</script>

<style scoped>
.tp-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 10px 7px 14px;
  border-radius: 999px;
  background: var(--tm-surface);
  border: 1px solid var(--tm-border);
  color: var(--tm-ink);
  font-size: 0.85rem;
  font-weight: 500;
  line-height: 1.2;
  box-shadow: var(--tm-shadow-sm);
  transition: background 0.15s ease, border-color 0.15s ease, transform 0.15s ease;
}

.tp-pill--solid {
  background: var(--tm-accent-wash);
  border-color: transparent;
  color: var(--tm-accent-deep);
  box-shadow: none;
}

.tp-pill--drag {
  cursor: grab;
}

.tp-pill--drag:active {
  cursor: grabbing;
}

.tp-pill__input {
  background: transparent;
  border: none;
  outline: none;
  font: inherit;
  color: inherit;
  min-width: 2ch;
  padding: 0;
}

.tp-pill__remove {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border: none;
  border-radius: 999px;
  background: transparent;
  color: currentColor;
  opacity: 0.55;
  cursor: pointer;
  padding: 0;
  transition: opacity 0.15s ease, background 0.15s ease;
}

.tp-pill__remove:hover {
  opacity: 1;
  background: rgba(0, 0, 0, 0.08);
}

.tp-pill--solid .tp-pill__remove:hover {
  background: rgba(11, 34, 57, 0.10);
}
</style>
